export class PersonRoleEnum {
	
	static SUPERADMIN: string = "SITEADMIN";
	static ADMIN: string = "ADMIN";
	static USER: string = "USER";
}

export class ChecklistTypeEnum {
	static TrainingPlan = 0;
	static Onboarding = 1;
}
export interface BlobResponse {
	blob: Blob,
	fileName: string
}